import {
  FETCH_STORE_RETURN_ORDER,
  RESET_STORE_RETURN_ORDER,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const storeReturnOrderView = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STORE_RETURN_ORDER:
      return { data: action.payload };
    case RESET_STORE_RETURN_ORDER:
      return initialState;
    default:
      return state;
  }
};

export default storeReturnOrderView;



// import {
//   FETCH_STORE_RETURN_ORDER,
//   RESET_STORE_RETURN_ORDER,
// } from "../../constants/action.constants";

// const initialState = {
//   payload: { limit: 10, total: 0, offset: 0 },
//   data: {},
//   others: {},
// };

// const storeReturnOrderView = (state = initialState, action) => {
//   switch (action.type) {
//     case FETCH_STORE_RETURN_ORDER:
//       return { 
//         data: action.payload.data,
//         payload: action.payload.payload,
//         others: action.others,
//       };
//     case RESET_STORE_RETURN_ORDER:
//       return initialState;
//     default:
//       return state;
//   }
// };

// export default storeReturnOrderView;
